import { hasMetadata } from "@/components/document-chat/services/streamEventTypes";
import { tryParseJSON } from "@/components/document-chat/utils";
import type { DocumentChatRuntime } from "../types";

/**
 * Extracts and sets sources from payload metadata
 *
 * @param contentObj - The content object that may contain metadata
 * @param runtime - The document chat runtime store interface
 */
export function extractAndSetSources(
  contentObj: unknown,
  runtime: DocumentChatRuntime
): void {
  try {
    // Check if content has metadata property
    if (!hasMetadata(contentObj)) {
      return;
    }

    const meta = contentObj.metadata;
    if (!meta) {
      return;
    }

    let parsed: unknown[] | null = null;
    if (typeof meta === "string") {
      const maybe = tryParseJSON<unknown[]>(meta);
      if (Array.isArray(maybe)) parsed = maybe;
    } else if (Array.isArray(meta)) {
      parsed = meta;
    }

    if (parsed && parsed.length > 0) {
      runtime.update({ sourcesFromMetadata: parsed });
    }
  } catch {
    // ignore metadata parse errors
  }
}
